import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PrintLog from './PrintLog';
import PrintJobContainer from './PrintJobContainer';
import PrintJobEditContainer from './PrintJobEditContainer';

const PrintLogRouter = () => (
  <Switch>
    <Route path="/UPD1/:id/edit" component={PrintJobEditContainer} />
    <Route path="/UPD1/:id" component={PrintJobContainer} />
    <Route component={PrintLog} />
  </Switch>
);

export default PrintLogRouter;
